import React from "react"
import styled from "styled-components"

const Chevron = ({ color }) => (
  <svg viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.22393 11.1558L0.483982 12.865L3.97597 12.865L10.084 6.86499L3.97597 0.86499L0.483983 0.864989L6.592 6.86499L2.22393 11.1558Z"
      fill={color ?? "#7E2D16"}
    />
  </svg>
)

export default styled(Chevron)``
